import { IconX } from "@tabler/icons-react";
import { formatDateTime } from "../../../utilities/helper";

type Props = {
  open: boolean;
  onClose: () => void;
  vehicleDetails: any;
};

const ViewRequestModal = ({ vehicleDetails, open, onClose }: Props) => {
  if (!open) return null;

  const data = {
    driver: vehicleDetails?.drivers_name,
    vehicleName: vehicleDetails?.vehicles_name,
    vehicleNumber: vehicleDetails?.vehicles_number,
    rcNumber: vehicleDetails?.vehicles_rc,
    makeModel: vehicleDetails?.vehicles_model,
    type: vehicleDetails?.vehicles_type,
    dateTime: vehicleDetails?.request_date,
    images: vehicleDetails?.images ?? [],
    reason: vehicleDetails?.reason,
    describe_reason: vehicleDetails?.describe_reason,
  };

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
      <div className="rounded-2xl">
        <div className="flex items-center">
          <div className=" bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4   w-full rounded-tl-3xl rounded-tr-[63px] ">
            <h1 className="text-2xl">View Request</h1>
          </div>
          <div className="relative ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={38}
              height={37}
              viewBox="0 0 38 37"
              fill="none"
              className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"
            >
              <path
                d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"
                fill="#F7F6F2"
              />
            </svg>

            <button
              onClick={onClose}
              className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"
            >
              <IconX size={20} />
            </button>
          </div>
        </div>
        <div className="w-full py-4 px-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
          <div className="w-[700px] max-h-[520px] overflow-y-auto space-y-4">
            {[
              ["Driver", data.driver],
              ["Vehicle Name", data.vehicleName],
              ["Vehicle Number", data.vehicleNumber],
              ["RC Number", data.rcNumber],
              ["Make & Model", data.makeModel],
              ["Type", data.type],
              [
                "Date & Time",
                data.dateTime ? formatDateTime(data.dateTime) : "—",
              ],
              ["Reason", data.reason],
              ["Describe Reason", data.describe_reason],
            ].map(([label, value]) => (
              <div key={label} className="flex justify-between">
                <div className="text-sm text-[#4B4B4B]">{label}</div>
                <div className="text-sm font-medium text-[#1E293B]">
                  {value || "—"}
                </div>
              </div>
            ))}

            {data.reason === "Accidentals" && (
              <div>
                <div className="text-sm text-[#4B4B4B] mb-2">
                  Vehicle Incident Images
                </div>
                {Array.isArray(data.images) && data.images.length > 0 ? (
                  <div className="grid grid-cols-4 gap-4">
                    {data.images.map((src: string, i: number) => (
                      <img
                        key={i}
                        src={src}
                        alt={`incident-${i}`}
                        className="w-[188px] h-[150px] rounded-md object-cover"
                      />
                    ))}
                  </div>
                ) : (
                  <p className="text-sm text-gray-500">No images available</p>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="px-6 py-4 flex justify-end space-x-2  bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px] "></div>
      </div>
    </div>
  );
};

export default ViewRequestModal;
